import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

const SecondaryControlButtonSizeRectangle = ({ className, width, height }) => {
  const classes = classNames({
    'print-product-configurator-controls-secondary-btn-rectangle': true,
    [className]: !!className,
  });

  const ratio = height / width;

  return (
    <div className={classes} style={{ paddingBottom: `${ratio * 100}%` }} />
  );
};

SecondaryControlButtonSizeRectangle.propTypes = propTypes;

export default SecondaryControlButtonSizeRectangle;
